import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { WorkflowExecVariable } from 'app/models/workflow-exec-variable';
import { WorkflowForm } from 'app/models/workflow-form';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { WorkflowExecVariableComponent } from '../workflow-exec-variable/workflow-exec-variable.component';

@Component({
  selector: 'app-prefix-suffix-builder',
  templateUrl: './prefix-suffix-builder.component.html',
  styleUrls: ['./prefix-suffix-builder.component.scss']
})
export class PrefixSuffixBuilderComponent implements OnInit {

  @Input() control: FormControl;
  @Input() workflowForms: WorkflowForm[];

  @ViewChild('prefixSuffixModal', { static: false }) prefixSuffixModal: ModalDirective;
  @ViewChild('workflowExecVariableComponent', { static: false }) workflowExecVariableComponent: WorkflowExecVariableComponent;
  
  @Output() close: EventEmitter<any> = new EventEmitter<any>();

  customText: string = '';

  constructor() { }

  ngOnInit(): void {
    if (!this.control.value) {
      this.control.setValue('');
    }
  }

  show() {
    this.customText = '';
    this.prefixSuffixModal.show();
  }

  onDone() {
    this.prefixSuffixModal.hide();
  }

  onClose() {
    this.close.emit();
  }

  onDynamicVariableOK(workflowExecVariable: WorkflowExecVariable) {
    if (workflowExecVariable) {
      this.control.setValue(this.control.value + '\{\{' + workflowExecVariable.workflow_form_name + '>>' + workflowExecVariable.fields[0].field_name + '\}\}');
      this.workflowExecVariableComponent.clear();
    }
  }

  onAddCustomText() {
    this.control.setValue(this.control.value + this.customText.replace(/(.{1})/g, '\\' + '$1'));
    this.customText = '';
  }
}
